import { ReactNode } from 'react';
import cx from 'classnames';
import { AnalyticsInfo } from './AnalyticsInfo';

export const AnalyticsCard = ({
    title,
    description,
    action,
    info,
    className,
    children,
}: {
    title: string;
    description?: string;
    action?: ReactNode;
    info?: ReactNode;
    className?: string;
    children: ReactNode;
}) => (
    <section className={cx('analytics-card', className)}>
        <header>
            <div className="analytics-card-heading">
                <div className="analytics-title-with-info">
                    <h3>{title}</h3>
                    {info && (
                        <AnalyticsInfo label={title}>{info}</AnalyticsInfo>
                    )}
                </div>
                {action}
            </div>
            {description && <p className="analytics-note">{description}</p>}
        </header>
        {children}
    </section>
);

export const AnalyticsChartFrame = ({
    embedded,
    ...props
}: Parameters<typeof AnalyticsCard>[0] & { embedded?: boolean }) =>
    embedded ? <>{props.children}</> : <AnalyticsCard {...props} />;
